import { navigateTo } from "../../framework/router.ts";
import { authContext } from "../../context/AuthContext.ts";
import { DashboardHistoricalHtml } from '../../components/skins/dashboard-historical.ts';
import {ExpandableDirectory} from '../../components/directory-list.ts';

export default function HistoricalPage() {
  const container = document.createElement("div");
  container.classList.add("parent-container");
  container.innerHTML = new DashboardHistoricalHtml().historicalskin();

   // Wait for the DOM to render before initializing the ExpandableDirectory
  requestAnimationFrame(() => {
    new ExpandableDirectory(".directory-list"); // pass selector if needed
  });

  return container;
}

